import { render, staticRenderFns } from "./u-select-filled-rounded.vue?vue&type=template&id=b053f658&scoped=true"
import script from "./u-select-filled-rounded.vue?vue&type=script&lang=js"
export * from "./u-select-filled-rounded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b053f658",
  null
  
)

export default component.exports